import { Link } from 'react-router-dom';
import { Seo } from '@/components/seo/Seo';
import { Container } from '@/components/ui/Container';

export const NotFoundPage = () => (
  <>
    <Seo title="Not found" description="This page could not be found." path="/404" />
    <Container>
      <section className="section-stack prose-page">
        <div className="section-heading">
          <h1>Page not found</h1>
          <p>The page you requested does not exist.</p>
        </div>
        <Link className="button button--primary" to="/">
          Return home
        </Link>
      </section>
    </Container>
  </>
);
